// import React, { useEffect, useState } from 'react'
// import { Box, List, ListItem, Switch, Typography } from '@mui/material'
// import FullLogoIcon from '../../Assets/Images/FullLogoIcon.png'
// import MessageIcon from '../../Assets/Images/MessageIcon.png'
// import DownArrow from '../../Assets/Images/DownArrow.png'


// function Header() {

//   const [darkTheme, setDarkTheme] = useState(false);

//   useEffect(() => {
//     document.documentElement.classList.toggle("dark", darkTheme);
//   }, [darkTheme]);
//   return (
//     <Box className='h-60px d-flex align-items-center justify-content-between px-4'>
//       <Box component={'img'} className='logo-icon' order={2} src={FullLogoIcon} maxHeight={'30px'}></Box>
//       {/* <Box className='d-flex align-items-center' gap={3} > */}
//       <List className='fs-18 d-flex text-color-main' order={1}>
//         <ListItem>About</ListItem>
//         <ListItem className='align-itmes-end'>Clients <Box component={'img'} src={DownArrow} maxHeight={'20px'}></Box></ListItem>
//         <ListItem className='align-itmes-end'>Services <Box component={'img'} src={DownArrow} maxHeight={'20px'}></Box></ListItem>
//         <ListItem className='align-itmes-end'>Blogs <Box component={'img'} src={DownArrow} maxHeight={'20px'}></Box></ListItem>
//       </List>
//       <Box className='d-flex align-items-center' gap={2} order={3}>
//         <Switch
//           checked={darkTheme}
//           onChange={()=>{setDarkTheme(!darkTheme)}}
//           slotProps={{ input: { 'aria-label': 'controlled' } }}
//         />
//         <Box className='d-flex align-items-center' order={3}>
//           <Typography className='chat-bg fs-18  bg-light-main text-color-main'>Let's Chat</Typography>
//           <Box component={'img'} src={MessageIcon} className='bg-light-main  message-bg' maxHeight={'55px'}></Box>
//         </Box>
//       </Box>
//       {/* </Box> */}
//     </Box>
//   )
// }

// export default Header

import React, { useEffect, useState } from "react";
import {
  Box,
  List,
  ListItem,
  Switch,
  Typography,
  IconButton,
  Drawer,
  useTheme,
  useMediaQuery
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import FullLogoIcon from "../../Assets/Images/FullLogoIcon.png";
import FullLogoIcon2 from "../../Assets/Images/Fulllogodarktheme.png";
import MessageIcon from "../../Assets/Images/MessageIcon.png";
import DownArrow from "../../Assets/Images/DownArrow.png";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../context/useAppContext";

function Header() {
  const { darkTheme, setDarkTheme } = useAppContext();

  const [openMenu, setOpenMenu] = useState(false);
  const navigate = useNavigate()
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));


  useEffect(() => {
    document.documentElement.classList.toggle("dark", darkTheme);
  }, [darkTheme]);

  const menuItems = [
    {
      title:"About",
      value:"about"
    },{
      title:"Clients",
      value:'clients'
    },
    {
      title:"Services",
      value:"services"
    },
    {
      title:"Case Studies",
      value:"case-studies"
    }
  ]
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // avoid micro flicker
      if (Math.abs(currentScrollY - lastScrollY) < 10) return;

      if (currentScrollY > lastScrollY && currentScrollY > 80) {
        setShowHeader(false); // scroll down
      } else {
        setShowHeader(true); // scroll up
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <Box
      className='h-60px'
      sx={{
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: darkTheme ? "black" : "white",
        px: 1,

        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 999,

        transform: showHeader ? "translateY(0)" : "translateY(-100%)",
        transition: "transform 0.3s ease-in-out",

        // optional premium feel 👇
        backdropFilter: "blur(8px)",
      }}
    >
      {/* Mobile Menu Icon */}
      <IconButton
        sx={{ display: { xs: "block", lg: "none" } }}
        onClick={() => setOpenMenu(true)}
      >
        <MenuIcon className={`fs-42 ${darkTheme ? "text-white" : 'text-dark'}`} />
      </IconButton>

      {/* Logo */}
      {/* {isMobile && (  */}
      <Box
        component="img"
        flex={1}
        mx={'auto'}
        src={darkTheme ? FullLogoIcon2 : FullLogoIcon}
        onClick={() => { navigate("/") }}
        sx={{
          height: { xs: "20px", sm: "50px", md: "70%" },
          objectFit: 'contain',
          order: { xs: 2, md: 1 }
        }}
      />
      {/* )} */}

      {/* Desktop Menu */}
      <List
        sx={{
          display: { xs: "none", lg: "flex" },
          fontSize: "18px",
          width: '40%',
          color: "var(--text-color-main)",
          justifyContent: 'flex-start',
          // overflow:"hidden"
        }}
      >
        {menuItems.map((item) => (
          <ListItem
            key={item}
            className="text-color-main"

            sx={{ display: "flex", width: 'fit-content', alignItems: "center", cursor: "pointer" }}
            onClick={() => { navigate(`/${item?.value?.toLowerCase()}`) }}
          >
            {item?.title}
            <Box
              component="img"
              src={DownArrow}
              sx={{ height: "18px", ml: 0.5 }}
            />
          </ListItem>
        ))}
      </List>


      {/* Right Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: 'end',
          gap: 2,
          width: { xs: "fit-content", md: '40%' },
          overflow: 'hidden',
          order: { xs: 3, md: 3 }
        }}
      >
        {/* <Switch
          checked={darkTheme}
          onChange={() => setDarkTheme(!darkTheme)}
        /> */}
        <label className="theme-switch">
          <input type="checkbox" checked={darkTheme} onChange={() => setDarkTheme(!darkTheme)} className="theme-switch__checkbox" />
          <div className="theme-switch__container">
            <div className="theme-switch__circle-container">
              <div className="theme-switch__sun-moon-container">
                <div className="theme-switch__moon">
                  <div className="theme-switch__spot"></div>
                  <div className="theme-switch__spot"></div>
                  <div className="theme-switch__spot"></div>
                </div>
              </div>
            </div>
          </div>
        </label>

        <Box onClick={() => { navigate('/contact') }} className='align-items-center' display={{ xs: "none", md: 'flex' }} order={3}>
          <Typography className='chat-bg fs-18  btn-light-main text-color-main'>Let's Chat</Typography>
          <Box component={'img'} src={MessageIcon} className='btn-light-main  message-bg' maxHeight={'55px'}></Box>
        </Box>
      </Box>

      {/* Mobile Drawer Menu */}
      <Drawer
        anchor="left"
        open={openMenu}
        onClose={() => setOpenMenu(false)}
      >
        <Box className='bg-light-main h-100 m-0' sx={{ width: 250, mt: 2 }}>
          <List>
            {menuItems.map((item) => (
              <>
                <ListItem
                  key={item}
                  className="text-color-main"
                  sx={{ cursor: "pointer" }}
                  onClick={() => { navigate(`/${item?.value?.toLowerCase()}`); setOpenMenu(false) }}
                >
                  {item?.title}
                </ListItem>
                <hr style={{ border: '1px solid var(--primary-dark-light-color)' }} />
              </>
            ))}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}

export default Header;
